export default {
	our_certificates(state) {
		return state.our_certificates
	},
}
